import React from "react";
import {Edit3} from "react-feather";

export default function DividerEdit() {
   return (
        <div className="divider my-2">
            <div className="divider-text"><Edit3 /></div>
        </div>
    )
}